var map = {
	"./customer-bg.webp": 1505,
	"./customer-img.webp": 1506,
	"./dice-img.webp": 1507,
	"./games-img.webp": 1508,
	"./lc-img.webp": 1509,
	"./lottery-img.webp": 1510,
	"./mission-bg.webp": 1511,
	"./mission-img-2.webp": 1512,
	"./mission-img.webp": 1513,
	"./mission-main-bg.webp": 1514,
	"./mobile-bg.webp": 1515,
	"./p2p-img.webp": 1516,
	"./product-bg.webp": 1517,
	"./product-main-bg.webp": 1518,
	"./sb-provider.webp": 1519,
	"./sbo-provider.webp": 1520,
	"./side-bar-bg.webp": 1521,
	"./slot-img.webp": 1522,
	"./spade-img.webp": 1523,
	"./sport-img.webp": 1524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;